export default {
	apps: {
		flow: "flow",
		widget: "widget",
	},
};
